<template>
  <div class="basic-info center">
    <tx-bg src="oldclassic_m_roleinfo_img_zb_db">
      <tx-bg src="oldclassic_m_roleinfo_img_biaoti" class="btn_yeqian">
        装备
      </tx-bg>

      <div class="flex-bw">
        <equipments
          class="equ_xiuwei_item"
          :new_equipments="new_equipments"
          :role_data="role_data"
        />

        <div class="equ_xiuwei_rank">
          <div class="wrapper">
            <tRow
              title="装备评价:"
              :value="(new_role?.equ_xiuwei || '').toString()"
              valueClass="row-value-bg"
            />
            <tRow
              title="全服排名:"
              :value="`${ranks.equ_xiuwei?.[''] || '没有上榜'}`"
              valueClass="row-value-bg"
            />
            <tRow
              title="本服排名:"
              :value="`${ranks.equ_xiuwei?.['server'] || '没有上榜'}`"
              valueClass="row-value-bg"
            />
            <tRow
              title="门派排名:"
              :value="`${ranks.equ_xiuwei?.['school'] || '没有上榜'}`"
              valueClass="row-value-bg"
            />
          </div>
        </div>
      </div>
    </tx-bg>

    <tx-bg src="oldclassic_m_roleinfo_img_sx_db" class="mt-40">
      <tx-bg src="oldclassic_m_roleinfo_img_biaoti" class="btn_yeqian">
        属性
      </tx-bg>

      <div class="flex-bw">
        <div class="roleinfo-attr-com pt-24">
          <div class="px-24">
            <t-row
              title="命"
              
              valueClass="roleinfo-attr-value row-value-bg"
              :value="new_attributes['生命值']"
            />

            <t-row
              title="技"
              valueClass="roleinfo-attr-value row-value-bg"
              :value="new_attributes['技力值']"
            />
          </div>

          <div class="grid-2 px-24 ">
            <t-row
              v-for="(attr, _index) in attr_list"
              :key="'attr' + _index"
              :title="attr"
              valueClass="roleinfo-attr-value row-value-bg"
              :value="new_attributes[attr]"
            />
          </div>

          <!-- 攻击属性 抗性、斩妖除魔、高级属性、真武属性-->
          <attact_attr :role_data="role_data" />
        </div>

        <xiuwei_attr :role_data="role_data"  class="xiuwei_rank" />
      </div>
    </tx-bg>
  </div>
</template>

<script setup>
import attact_attr from './basic_info_c/attact_attr.vue';
import xiuwei_attr from './basic_info_c/xiuwei_attr.vue';
import other_attr from './basic_info_c/other_attr.vue';
import equipment_tips from './equipment_tips.vue';

import equipments from './basic_info_c/equipments.vue';

const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

const attr_list = ref(['力', '体', '敏', '疾', '魂', '念']);

const new_role = computed(() => {
  return props.role_data?.new_role || {};
});

const new_attributes = computed(() => {
  return props.role_data?.new_attributes || {};
});

const ranks = computed(() => {
  return props.role_data?.ranks || {};
});

const new_equipments = computed(() => {
  return props.role_data?.new_equipments || {};
});
</script>
